import React, { useState, useRef, useEffect, useContext } from 'react';
import styled from 'styled-components';

import {
	Grid,
	Container,
	Typography,
	Slide,
	ClickAwayListener,
	IconButton,
} from '@material-ui/core/';

import { v4 as uuidv4 } from 'uuid';
import { ProjectDataContext } from '../context/ProjectDataState';
import {
	generateAblageLocation,
	generateAblageProject,
} from '../services/generatePortfolioData';

import CardWrapper from '../components/common/CardWrapper';
import BsScatterChart from '../components/charts/scatterChart';
// eslint-disable-next-line import/no-cycle
import TablePortfolio from '../components/tables/TablePortfolio';
import ModalUploadLoadProfile from '../components/modals/ModalUploadLoadProfile';
import StickyAppBar from '../components/common/StickyAppBar';
import ModalRename from '../components/modals/ModalRename';
import ModalCreateGroup from '../components/modals/ModalCreateGroup';
// eslint-disable-next-line import/no-cycle
import OptionsMenu from '../components/menus/OptionsMenu';
import ModalConfirmDelete from '../components/modals/ModalConfirmDelete';
import ModalAddInformation from '../components/modals/ModalAddInformation';
import ModalCreateLocation from '../components/modals/ModalCreateLocation';

// Intilion
import IconOptions from '../assets/icon-options.svg';
import IconDelete from '../assets/icon-delete.svg';
import IconPlus from '../assets/icon-plus.svg';
import IconList from '../assets/icon-list.svg';
import IconDotGraph from '../assets/icon-dot-graph.svg';

const ScatterContainer = styled(Grid)`
	width: 100%;
	height: 100%;
	min-height: 600px;
	background-color: white;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
	padding: 32px;
	box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
`;

const Root = styled.div`
	.MuiContainer-root {
		margin-top: 40px;
	}

	h5 {
		font-size: 24px;
		font-weight: bold;
	}

	.actions {
		position: relative;
		display: flex;
		align-items: center;

		.action__item {
			position: relative;
		}
	}
`;

export const PROJECT = 'project';
export const LOCATION = 'location';
export const CUSTOMER = 'customer';
export const SCATTERCHART = 'scatterChart';

export const RENAMEMODAL = 'renameModal';
export const OPENLASTGANGMODAL = 'openLastGangModal';
export const CREATEGROUPMODAL = 'createGroupModal';
export const DELETECONFIRMMODAL = 'deleteConfirmModal';
export const ADDINFORMATIONMODAL = 'addInformationModal';
export const CREATELOCATIONMODAL = 'createLocationModal';

// eslint-disable-next-line arrow-body-style
const generateScatterData = Array.from({ length: 25 }, () => {
	return {
		x: Math.floor(Math.random() * 32000) + 1,
		y: Math.floor(Math.random() * 800) + 1,
		z: Math.floor(Math.random() * 1200) + 1,
	};
});

const PagePortfolio = ({ comingFromStartseitePage }) => {
	const [bsScatterChart, showBsScatterChart] = useState(false);
	const [openOptionsMenu, setOpenOptionsMenu] = useState(false);
	const anchorOptionsMenu = useRef(null);

	const [selectedLocationName, setSelectedLocationName] = useState(null);
	const [selectedProjectID, setSelectedProjectID] = useState(null);
	const [selectedLocationID, setSelectedLocationID] = useState(null);
	const [selectedCustomerID, setSelectedCustomerID] = useState(null);
	const [optionsMenueClickable, setOptionsMenueClickable] = useState({
		delete: false,
		menue: false,
		scatterChart: true,
		addNewGroup: true,
		inputRenameLabel: '',
		addInformationData: {},
	});

	const { projectData, setProjectData } = useContext(ProjectDataContext);
	const [openLastGangModal, setOpenLastgangModal] = useState(false);
	const [openRenameModal, setOpenRenameModal] = useState(false);
	const [openCreateGroupModal, setOpenCreateGroupModal] = useState(false);
	const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
	const [openAddInformationModal, setOpenAddInformationModal] = useState(false);
	const [openCreateLocationModal, setOpenCreateLocationModal] = useState(false);
	const [currentSelectedComponent, setCurrentSelectedComponent] = useState(null);
	const [addInformationModalData, setAddInformationModalData] = useState({});
	const [activeSelectedItemKey, setActiveSelectedItemKey] = useState(null);
	const [triggerMe, setTriggerMe] = useState(false);

	useEffect(() => {
		if (currentSelectedComponent === null) {
			return;
		}
		handleMenueVisibility();
	}, [triggerMe]); // eslint-disable-line react-hooks/exhaustive-deps

	const handleActiveSelectedItemKey = (id) => {
		if (activeSelectedItemKey === id) {
			return (
				setActiveSelectedItemKey(null), setCurrentSelectedComponent(SCATTERCHART)
			);
		}
		setActiveSelectedItemKey(id);
	};

	const handleMenueVisibility = () => {
		const newData = projectData;
		switch (currentSelectedComponent) {
			case PROJECT:
				setOptionsMenueClickable({
					...optionsMenueClickable,
					delete: true,
					menue: true,
					scatterChart: true,
					addNewGroup: false,
					inputRenameLabel: newData[selectedProjectID].projectName,
				});
				break;

			case LOCATION:
				setSelectedLocationName(
					newData[selectedProjectID].projectData[selectedLocationID].location
				);
				setOptionsMenueClickable({
					delete: true,
					menue: true,
					scatterChart: true,
					addNewGroup: false,
					inputRenameLabel:
						newData[selectedProjectID].projectData[selectedLocationID]
							.location,
				});
				setAddInformationModalData(
					newData[selectedProjectID].projectData[selectedLocationID]
				);
				break;

			case CUSTOMER:
				setOptionsMenueClickable({
					delete: false,
					menue: false,
					scatterChart: true,
					addNewGroup: false,
					inputRenameLabel: 'Lastgang',
				});
				break;

			case SCATTERCHART:
				setActiveSelectedItemKey(null);
				setOptionsMenueClickable({
					delete: false,
					menue: false,
					scatterChart: true,
					addNewGroup: true,
				});
				break;

			default:
				break;
		}
	};

	const defaultViewAndSelection = () => {
		setOptionsMenueClickable({
			...optionsMenueClickable,
			delete: false,
			menue: false,
			scatterChart: true,
			addNewGroup: true,
		});
		setCurrentSelectedComponent(null);
	};

	const handleDelete = () => {
		const newData = projectData;

		switch (currentSelectedComponent) {
			case PROJECT:
				delete newData[selectedProjectID];
				setProjectData({ ...newData });
				defaultViewAndSelection();
				break;

			case LOCATION:
				delete newData[selectedProjectID].projectData[selectedLocationID];
				setProjectData({ ...newData });
				defaultViewAndSelection();
				break;

			case CUSTOMER:
				delete newData[selectedProjectID].projectData[selectedLocationID]
					.customerData[selectedCustomerID];
				setProjectData({ ...newData });
				defaultViewAndSelection();
				break;

			default:
				break;
		}
	};

	const toggleModals = (modal) => {
		switch (modal) {
			case RENAMEMODAL:
				setOpenRenameModal(!openRenameModal);
				break;
			case OPENLASTGANGMODAL:
				setOpenLastgangModal(!openLastGangModal);
				break;
			case CREATEGROUPMODAL:
				setOpenCreateGroupModal(!openCreateGroupModal);
				break;
			case DELETECONFIRMMODAL:
				setOpenDeleteConfirmModal(!openDeleteConfirmModal);
				break;
			case ADDINFORMATIONMODAL:
				setOpenAddInformationModal(!openAddInformationModal);
				break;
			case CREATELOCATIONMODAL:
				setOpenCreateLocationModal(!openCreateLocationModal);
				break;
			default:
				break;
		}
	};

	const toggleOptionsMenu = (event) => {
		if (
			anchorOptionsMenu.current &&
			anchorOptionsMenu.current.contains(event.target)
		) {
			return;
		}

		setOpenOptionsMenu(!openOptionsMenu);
	};

	const renameSelectedTableComponent = (inputData) => {
		const newData = projectData;

		switch (currentSelectedComponent) {
			case PROJECT:
				newData[selectedProjectID].projectName = inputData;
				setProjectData({ ...newData });
				defaultViewAndSelection();
				break;

			case LOCATION:
				newData[selectedProjectID].projectData[
					selectedLocationID
				].location = inputData;
				setProjectData({ ...newData });
				defaultViewAndSelection();
				break;

			case CUSTOMER:
				break;

			default:
				break;
		}
	};

	const addNewProject = (projectName, locationName) => {
		const newData = projectData;
		const POJECTUUID01 = uuidv4();
		const STANDORTUUID01 = uuidv4();
		const blankoProjectData = generateAblageProject(projectName, POJECTUUID01);

		blankoProjectData[POJECTUUID01].projectData = generateAblageLocation(
			locationName,
			STANDORTUUID01,
			POJECTUUID01
		);
		const selectedprojectString = `${POJECTUUID01}_${STANDORTUUID01}`;
		setSelectedLocationName(locationName);
		setProjectData({ ...blankoProjectData, ...newData });
		setSelectedLocationID(selectedprojectString);
	};

	const addNewLocation = (locationName) => {
		const newData = projectData;
		const STANDORTUUID01 = uuidv4();
		const blankoLocationData = generateAblageLocation(
			locationName,
			STANDORTUUID01,
			selectedProjectID
		);
		newData[selectedProjectID].projectData = {
			...blankoLocationData,
			...newData[selectedProjectID].projectData,
		};
		setProjectData({ ...newData });
		const genereateCorrectLocationString = `${selectedProjectID}_${STANDORTUUID01}`;

		setSelectedLocationID(genereateCorrectLocationString);
		setCurrentSelectedComponent(LOCATION);
		setTriggerMe(!triggerMe);
	};

	const addInformation = (data) => {
		const newData = projectData;
		newData[selectedProjectID].projectData[selectedLocationID] = {
			...data,
		};
		setProjectData({ ...newData });
	};

	return (
		<Root>
			<Container maxWidth="lg">
				<ClickAwayListener
					onClickAway={() => {
						setActiveSelectedItemKey(null);
						defaultViewAndSelection();
					}}
				>
					<>
						{/* StickyBar */}
						<StickyAppBar hide={comingFromStartseitePage}>
							<Typography variant="h5">Mein Portfolio</Typography>
							<div className="actions">
								{optionsMenueClickable.menue && (
									<div className="action__item">
										<IconButton
											onClick={() => {
												setOpenOptionsMenu(!openOptionsMenu);
											}}
											ref={anchorOptionsMenu}
											aria-controls="optionsMenu"
											aria-haspopup="true"
										>
											<img
												src={IconOptions}
												alt="Optionen anzeigen"
											/>
										</IconButton>
										<OptionsMenu
											openOptionsMenu={openOptionsMenu}
											anchorOptionsMenu={anchorOptionsMenu}
											toggleOptionsMenu={toggleOptionsMenu}
											toggleOpenLastgangModal={() =>
												toggleModals(OPENLASTGANGMODAL)
											}
											toggleRenameModal={() =>
												toggleModals(RENAMEMODAL)
											}
											toggleAddInformation={() =>
												toggleModals(ADDINFORMATIONMODAL)
											}
											toggleCreateLocationModal={() =>
												toggleModals(CREATELOCATIONMODAL)
											}
											visibilityBySelectedComponent={
												currentSelectedComponent
											}
										/>
									</div>
								)}
								{optionsMenueClickable.delete && (
									<IconButton
										onClick={() => setOpenDeleteConfirmModal(true)}
									>
										<img src={IconDelete} alt="Löschen" />
									</IconButton>
								)}
								{optionsMenueClickable.addNewGroup && (
									<IconButton
										onClick={() => setOpenCreateGroupModal(true)}
									>
										<img src={IconPlus} alt="Hinzufügen" />
									</IconButton>
								)}
								{!optionsMenueClickable.scatterChart && (
									<IconButton
										onClick={() => {
											showBsScatterChart(!bsScatterChart);
											setTriggerMe(!triggerMe);
											setCurrentSelectedComponent(SCATTERCHART);
										}}
									>
										<img
											src={bsScatterChart ? IconList : IconDotGraph}
											alt="Graphen anzeigen"
										/>
									</IconButton>
								)}
							</div>
						</StickyAppBar>

						{/* ScatterContainer */}
						<Slide
							direction="left"
							in={bsScatterChart}
							mountOnEnter
							unmountOnExit
						>
							<ScatterContainer>
								<BsScatterChart
									data={generateScatterData}
									xAxisName="Einsparpotential"
									yAxisName="Stromverbrauch"
									zAxisName="TBD"
									dataKeyX="x"
									dataKeyY="y"
									dataKeyZ="z"
									unitX=" €"
									unitY=" MW"
									unitZ=""
								/>
							</ScatterContainer>
						</Slide>

						{/* Portfolio Items */}
						{Object.keys(projectData).map((e, index) => (
							/* eslint-disable no-shadow */
							<CardWrapper
								key={projectData[e].id}
								style={{
									boxShadow: !comingFromStartseitePage ? '' : 'none',
								}}
								onClick={() => {
									setSelectedProjectID(projectData[e].id);
								}}
							>
								<TablePortfolio
									projectID={projectData[e].id}
									data={projectData[e].projectData}
									projectName={`${projectData[e].projectName}-${index}`}
									selectedCustomerID={(e) => setSelectedCustomerID(e)}
									selectedLocationID={(e) => setSelectedLocationID(e)}
									selectedComponent={(e) => {
										setTriggerMe(!triggerMe);
										setCurrentSelectedComponent(e);
									}}
									setActiveSelectedItemKey={(e) =>
										handleActiveSelectedItemKey(e)
									}
									activeSelectedItemKey={activeSelectedItemKey}
								/>
							</CardWrapper>
						))}
					</>
				</ClickAwayListener>
			</Container>

			<ModalUploadLoadProfile
				comingFromPortolio
				toggleModal={() => toggleModals(OPENLASTGANGMODAL)}
				openLastgangDialog={openLastGangModal}
				selectedLocationID={selectedLocationID}
				selectedLocationName={selectedLocationName}
			/>

			{/* Modal: Neue Gruppe anlegen */}
			{optionsMenueClickable.addNewGroup && (
				<ModalCreateGroup
					openCreateGroupModal={openCreateGroupModal}
					toggleCreateGroupModal={() => toggleModals(CREATEGROUPMODAL)}
					toggleLastgangHochladen={() => toggleModals(OPENLASTGANGMODAL)}
					addNewProject={addNewProject}
				/>
			)}

			{/* Modal: Umbenennen */}
			{optionsMenueClickable.menue && (
				<ModalRename
					headline="Neuen Namen eingeben"
					openRenameModal={openRenameModal}
					renameSelectedTableComponent={renameSelectedTableComponent}
					optionsMenueClickable={optionsMenueClickable}
					toggleRenameModal={() => toggleModals(RENAMEMODAL)}
				/>
			)}

			{/* Modal: Niederlassung erstellen */}
			<ModalCreateLocation
				open={openCreateLocationModal}
				toggle={() => toggleModals(CREATELOCATIONMODAL)}
				toggleLastgangHochladen={() => toggleModals(OPENLASTGANGMODAL)}
				toggleAddInformationModal={() => toggleModals(ADDINFORMATIONMODAL)}
				addLocation={addNewLocation}
			/>

			{/* Modal: Löschen bestätigen */}
			{optionsMenueClickable.delete && (
				<ModalConfirmDelete
					openDeleteConfirmModal={openDeleteConfirmModal}
					toggleOpenDeleteConfirmModal={() => toggleModals(DELETECONFIRMMODAL)}
					handleDelete={handleDelete}
					selectedName={optionsMenueClickable.inputRenameLabel}
				/>
			)}

			{/* Modal: Informationen hinzufügen */}
			<ModalAddInformation
				open={openAddInformationModal}
				toggle={() => toggleModals(ADDINFORMATIONMODAL)}
				recieveData={addInformationModalData}
				addData={addInformation}
			/>
		</Root>
	);
};

export default PagePortfolio;
